<template>
  <LayoutBasic
    :showLinksMenu="false"
    :routeBack="{ name: 'empresa.sucursal.productos' }"
    v-if="producto"
  >
    <template #navigation-title>
      <div class="text-h6 font-weight-bold">Producto de la sucursal</div>
    </template>

    <template #navigation-content>
      <!-- Header compacto del producto -->
      <div class="px-1 mb-4">
        <div v-if="producto.marca" class="caption grey--text text--lighten-1 mb-1">
          {{ producto.marca.nombre }}
        </div>
        <div class="text-subtitle-1 font-weight-bold white--text text-wrap mb-1">
          {{ producto.descripcion }}
        </div>
        <div v-if="producto.categoriaArbol && producto.categoriaArbol.id">
          <v-chip x-small class="mt-1">{{ producto.categoriaArbol.name }}</v-chip>
        </div>
        <div class="caption grey--text mt-2">
          Actualizado el {{ moment(producto.fechaActualizacion).format("ll") }}
        </div>
      </div>

      <v-divider class="grey darken-3 mb-2"></v-divider>

      <!-- Menú de navegación -->
      <v-list dense nav>
        <v-list-item
          :to="{ name: 'empresa.sucursal.productos.item' }"
          exact
          class="rounded-lg"
        >
          <v-list-item-icon>
            <v-icon small>mdi-information-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Detalles</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          :to="{ name: 'empresa.sucursal.productos.item.inventario.stock' }"
          class="rounded-lg"
        >
          <v-list-item-icon>
            <v-icon small>mdi-package-variant-closed</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Stock</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          :to="{ name: 'empresa.sucursal.productos.item.historial' }"
          class="rounded-lg"
        >
          <v-list-item-icon>
            <v-icon small>mdi-history</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Historial</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-if="producto.parent && configuracion.productosFraccionados"
          class="rounded-lg"
          @click="changeParam(producto.parent)"
        >
          <v-list-item-icon>
            <v-icon small>mdi-link-variant</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="text-wrap">Es producto de</v-list-item-title>
            <v-list-item-subtitle>{{ producto.parent_name.toUpperCase() }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
    <template v-slot:navigation-controller> </template>

    <template v-slot:navigation-stepper> </template>
    <template v-slot:navigation-append> </template>
    <template v-slot:vista-previa>
      <v-row
        align="center"
        justify="center"
        v-if="!loadingFetch"
        class="mt-2 mx-auto"
      >
        <v-col cols="12">
          <v-container>
            
            <router-view :productoProp="producto"></router-view>
          </v-container>
        </v-col>
      </v-row>
    </template>
  </LayoutBasic>
</template>
  
<script>
import { administrarMixin } from "@/mixins/producto/administrarMixin.js";
import LayoutBasic from "@/layouts/LayoutBasic.vue";
import LayoutRegistrarProducto from "@/layouts/productos/layout.registrar.producto";

import { mapActions, mapGetters, mapState } from "vuex";
import ProductosAPI from "@/api/productos";

export default {
  name: "SucursalProductosItemLayout",
  components: {
    LayoutRegistrarProducto,
    LayoutBasic,
  },
  $_veeValidate: {
    validator: "new",
  },
  mixins: [administrarMixin],
  data() {
    return {
      loadingFetch: false,
      producto: null,
      dialogCalculator: false,
      loadingProductosFraccionados: false,
      productosFraccionados: null,
    };
  },
  computed: {
    ...mapState("sucursales", ["configuracion"]),
    ...mapGetters("admin", ["sucursalSeleccionada"]),
  },

  methods: {
    setPrecioCosto(precio) {
      this.producto.precioCosto = precio;
    },
    setGanancia(precio) {
      this.producto.ganancia = precio;
    },

    fetchProducto(id) {
      this.loadingFetch = true;
      ProductosAPI.showPsp(id).then((response) => {
        this.producto = response.data;
        if (!this.producto.categoriaArbol) {
          this.producto.categoriaArbol = { id: null };
        }
        this.loadingFetch = false;
      }).catch(() => {
        this.loadingFetch = false;
      });
    },
    changeParam(id) {
      this.$router.replace({ name: "productoHome", params: { id: id } });
      this.fetchProducto(id);
    },
  },
  created() {
    console.log(this.$route.params);

    if (this.$route.params.producto === undefined) {
      this.fetchProducto(this.$route.params.id_producto_sucursal);
    } else {
      this.loadingFetch = true;
      var producto = this.$route.params.producto;
      if (!producto.categoriaArbol) {
        producto.categoriaArbol = { id: null };
      }

      producto.categoriaArbol = producto.categoriaArbol
        ? producto.categoriaArbol
        : { id: null };
      this.producto = producto;

      this.loadingFetch = false;
    }
  },
};
</script>
  
<style scoped>
</style>
  